import { ourPreviousWork } from "./ourPreviousWork.css";

interface ourPreviousWorkCssProps {
  testimonialsBackgroundColor?: string;
}

export const ourPreviousWorkCss = (props: ourPreviousWorkCssProps) => (`

  ${ourPreviousWork}

  .testimonials--bottom-nav-container {
    background-color: ${props.testimonialsBackgroundColor ?? "#FCEDBD"}
  }

`)